<script>
import { deliveryInfoProps, useDeliveryInfo } from "./mixin";

import LazyImage from "@/components/atoms/lazy-image";
import List from "@/components/molecules/list";
import ListItem from "@/components/molecules/list/list-item";
import SecuredDownloadButton from "@/containers/secured-download-button";
import Divider from "@/components/atoms/divider";
import Button from "@/components/atoms/button";
import PopinClickCollectTraiteurFetes from "@/components/organisms/popin-cc-traiteur-fetes";
import scannerBonRetrait from "@/assets/images/scanner-bon-retrait.svg";
import presenterBonRetrait from "@/assets/images/presenter-bon-retrait.svg";

export default {
  name: "OrderConfirmationDeliveryInfoDrive",
  components: {
    SecuredDownloadButton,
    LazyImage,
    List,
    ListItem,
    Divider,
    Button,
    PopinClickCollectTraiteurFetes
  },
  props: {
    magasin: {
      type: Object,
      required: false,
      default: () => {}
    },
    popinSlideUp: {
      type: Boolean,
      required: false,
      default: false
    },
    ...deliveryInfoProps()
  },
  setup(props) {
    const Button = defineAsyncComponent(() =>
      import("@/components/atoms/button")
    );
    const { printFile } = useDeliveryInfo(props);
    return { printFile, scannerBonRetrait, presenterBonRetrait, Button };
  }
};
</script>

<template>
  <div class="u-border-grey-4 u-p-md u-radius-sm u-mb-md">
    <PopinClickCollectTraiteurFetes
      ref="traiteurFete"
      :slide-up="popinSlideUp"
      :magasin="magasin"
    />
    <h2 class="u-font-24 u-color-primary u-mb-sm">
      Comment retirer votre commande Traiteur de Fêtes
    </h2>
    <Divider
      dotted
      size="sm"
      class="u-mb-md"
    />

    <List class="c-order-confirmation__delivery-list">
      <ListItem class="c-order-confirmation__delivery-list-item">
        <LazyImage
          :src="presenterBonRetrait"
          size="lg"
          height="72"
          width="72"
          class="u-mr-sm u-mr-none@sm"
        />
        <div class="u-pl-sm@sm u-full-width">
          <p class="c-order-confirmation__delivery-list-item-title">
            Présentez votre bon de retrait ou votre email de confirmation au {{ lieuRetrait }}
          </p>
          <p class="u-font-15 u-font-secondary u-mb-xxs">
            Votre n° de commande se trouve sur celui-ci {{ code }}
          </p>
          <Button
            link
            class="u-text-left"
            @click="$refs.traiteurFete.show()"
          >
            <span>Voir l’emplacement du {{ lieuRetrait }}</span>
          </Button>
        </div>
      </ListItem>

      <ListItem class="c-order-confirmation__delivery-list-item">
        <LazyImage
          :src="scannerBonRetrait"
          size="lg"
          height="72"
          width="72"
          class="u-mr-sm u-mr-none@sm"
        />
        <div class="u-pl-sm@sm u-full-width">
          <p class="c-order-confirmation__delivery-list-item-title">
            Scannez votre bon de retrait
          </p>
          <p class="u-font-15 u-font-secondary">
            <SecuredDownloadButton
              :component="Button"
              link
              :secured-link="pdfUrl"
              @download="printFile"
            >
              Imprimer le bon de retrait
            </SecuredDownloadButton>
          </p>
        </div>
      </ListItem>
    </List>
    <p class="u-font-14 u-color-grey-2 u-mb-xs u-mt-lg">
      Cora se réserve le droit de vous demander de présenter une pièce d’identité.
    </p>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/order-confirmation.scss";
</style>
